import React, {useCallback} from 'react';
import {AddApplianceForm} from 'components/customer/Product/Appliance/AddApplianceForm';
import {RANGEHOOD} from 'components/customer/Product/store/productApi';
import {useConfirmationDialog} from 'shared/components/ConfirmationDialog/ConfirmationDialog';
import {useFetchAppliancesQuery} from 'components/customer/Product/Appliance/store/applianceApi';
import {useFormikContext} from 'formik';
import {ApplianceForm} from 'components/customer/Product/Appliance/Select';

export const useApplianceForm = (
    name: string,
    type: number,
    heightSetCallback: (value: number) => void
) => {
    const {showDialog, hideDialog, dialog} = useConfirmationDialog();
    const {data: appliances} = useFetchAppliancesQuery();
    const {values, setFieldValue} = useFormikContext<ApplianceForm>();

    const applianceForm = useCallback(
        (overrideAdd = false) => {
            if (appliances) {
                let title = 'Add custom appliance';

                if (type == RANGEHOOD) {
                    title = 'Add custom rangehood';
                }

                if (showDialog) {
                    showDialog({
                        title: title,
                        message: (
                            <AddApplianceForm
                                overrideAdd={overrideAdd}
                                name={name}
                                hideDialog={hideDialog}
                                makes={Array.from(
                                    new Set(
                                        appliances.map(
                                            (appliance) => appliance.make
                                        )
                                    )
                                )}
                                heightSetCallback={heightSetCallback}
                            />
                        ),
                        hideYesButton: true,
                        hideNoButton: true,
                        hideFooter: true,
                    });
                }
            }
        },
        [showDialog, type, appliances, heightSetCallback]
    );

    const showApplianceForm = useCallback(
        (check = true) => {
            if (
                values &&
                'appliance' in values &&
                showDialog &&
                values.appliance.custom &&
                check
            ) {
                showDialog({
                    title: 'Add new Rangehood?',
                    message:
                        'You have already added a custom rangehood. Do you want to replace this with new one or edit the existing one?',
                    hideYesButton: true,
                    hideNoButton: true,
                    buttons: [
                        {
                            show: true,
                            name: 'Cancel',
                            variant: 'danger',
                            alignLeft: true,
                        },
                        {
                            show: true,
                            name: 'Add new',
                            variant: 'warning',
                            action: () => {
                                applianceForm(true);
                            },
                        },
                        {
                            show: true,
                            name: 'Edit existing',
                            action: () => {
                                applianceForm();
                            },
                        },
                    ],
                });
            } else {
                applianceForm();
            }
        },
        [showDialog, values, applianceForm, setFieldValue]
    );

    return {
        showApplianceForm,
        dialog,
    };
};
